/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { JobUpdateStatus } from './jobUpdateStatus';

export interface JobUpdate {
  title?: string | null;
  description?: string | null;
  project_id?: string | null;
  job_manager_id?: string | null;
  employer_id?: string | null;
  status?: JobUpdateStatus;
  is_archived?: boolean | null;
  wizard_step?: number | null;
}
